// Warning banner listing companies whose QuickBooks connection has expired.
// Shown on both the Generate Reports and Companies pages.
// Styles live in styles/companies.css under "NOTICE BANNER".
function ExpiredConnectionsBanner({ companies, actionLabel, onAction }) {
  if (!companies || companies.length === 0) return null;

  const names = companies.map((c) => c.companyName).join(", ");
  const many = companies.length > 1;

  return (
    <div className="notice" role="status">
      <div className="notice-body">
        <span className="notice-icon" aria-hidden="true">⚠️</span>
        <div>
          <p className="notice-title">
            QuickBooks {many ? "connections" : "connection"} expired
          </p>
          <p className="notice-text">
            <strong>{names}</strong> {many ? "need" : "needs"} to be reconnected
            — {many ? "their" : "its"} data will be missing from reports until
            you sign in to QuickBooks again.
          </p>
        </div>
      </div>

      {onAction && (
        <button
          type="button"
          className="btn btn-brand btn-sm"
          onClick={onAction}
        >
          {actionLabel || "Reconnect QuickBooks"}
        </button>
      )}
    </div>
  );
}

export default ExpiredConnectionsBanner;
